import { render, staticRenderFns } from "./RabbeyTablesTabs2.vue?vue&type=template&id=504c5e9c&"
import script from "./RabbeyTablesTabs2.vue?vue&type=script&lang=js&"
export * from "./RabbeyTablesTabs2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports